import { Link } from 'react-router-dom';

const BRANDS = [
  ['Mini GT', '/collections/mini-gt'], ['INNO64', '/collections/inno64'], ['Hot Wheels', '/collections/hot-wheels'],
  ['Pop Race', '/collections/pop-race'], ['Tarmac Works', '/collections/tarmac-works'],
  ['Greenlight', '/collections/greenlight-collectibles'], ['Bburago', '/collections/bburago'],
];
const COLLECTIONS = [
  ['1:64 Diecast Models', '/collections/1-64-diecast-models'], ['Hot Wheels Premium', '/collections/hot-wheels-premium'],
  ['Imported Hot Wheels', '/collections/imported-hot-wheels'], ['JDM Diecast Cars', '/collections/jdm-diecast-cars'],
  ['Limited & Event Editions', '/collections/limited-edition-models'], ['Bburago Formula 1', '/collections/bburago-formula-1'],
  ['INNO64 Pre-Orders', '/collections/inno64-pre-orders'], ['All Pre-Orders', '/pre-orders'],
];

const LinkRow = ({ title, items, id }) => (
  <div>
    <h3 className="text-[10px] font-bold uppercase tracking-[0.25em] text-gray-400 mb-3">{title}</h3>
    <ul className="flex flex-wrap gap-2" data-testid={`home-seo-${id}`}>
      {items.map(([label, to]) => (
        <li key={to}><Link to={to} data-testid={`home-seo-link-${to.split('/').pop()}`}
          className="inline-block text-xs font-semibold px-3 py-1.5 rounded-full border border-gray-200 text-[#1A1A1A] hover:border-[#FF2A2A] hover:text-[#FF2A2A] transition-colors">{label}</Link></li>
      ))}
    </ul>
  </div>
);

export default function HomeSeoIntro() {
  return (
    <section data-testid="home-seo-intro" aria-labelledby="home-seo-intro-heading" className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] gap-12">
        <div>
          <h2 id="home-seo-intro-heading" className="font-heading text-2xl sm:text-3xl font-black tracking-tight text-[#1A1A1A]">Diecast models in India, picked by collectors</h2>
          <div className="mt-5 space-y-3 text-sm sm:text-base text-gray-600 leading-relaxed">
            <p>OGMini is a diecast model and collectibles store based in Hyderabad, with an experience centre for visiting collectors and online ordering with delivery across India through ogmini.com.</p>
            <p>Most of our range is 1:64 diecast models from brands such as Mini GT, INNO64, Pop Race, Tarmac Works and Hot Wheels, alongside larger 1:43, 1:24 and 1:18 pieces from Bburago and others. Every listing shows its scale, brand and whether it is in stock or open for pre-order.</p>
            <p>New announcements, especially Inno64 releases, usually open as pre-orders first: reserve with a small deposit and pay the balance when the model arrives.</p>
          </div>
        </div>
        <div className="space-y-8">
          <LinkRow title="Shop by brand" items={BRANDS} id="brands" />
          <LinkRow title="Popular collections" items={COLLECTIONS} id="collections" />
          <p className="text-xs text-gray-500"><Link to="/brands" className="font-semibold text-[#FF2A2A]" data-testid="home-seo-all-brands">See every brand</Link> · <Link to="/shop" className="font-semibold text-[#FF2A2A]" data-testid="home-seo-all-products">Browse all diecast models</Link></p>
        </div>
      </div>
    </section>
  );
}
